<script lang="ts">
  import MelPlayer from "./MelPlayer.svelte";
  import { onMount } from "svelte";
  import { Howl, Howler } from "howler";
	import vhCheck from 'vh-check'

  let loaded = false;
  let audio;
  let audio_id;

  onMount(() => {
		vhCheck()
    audio = new Howl({
      src: ["assets/circle_verse.wav"],
      loop: true,
      volume: 0.0,
      onfade: (e) => {
				console.log(e)
        // if (audio.volume() == 0) {
        //   audio.stop();
        // }
      },
    });
  });
</script>
<svelte:head>
	<title>CIRCULUS - Cirvleverse</title>
</svelte:head>

<main>
  <MelPlayer
    src={"assets/circle_verse_def.mp4"}
    src_mobile={"assets/circle_verse.mp4"}
    on:loaded={(ev) => {
      console.log(ev);
    }}
    on:click={(ev) => {
      if (audio.volume() == 1) {
				console.log(`Fading out ${audio.volume()}`);
        audio.fade(1, 0, 1000);
      } else if (audio.volume() == 0) {
        if (!audio_id) {
					console.log("First time here? Hello");
          audio_id = audio.play();
        }
					console.log(`Fading in ${audio.volume()}`);
          audio.fade(0, 1, 1000);
      }

      console.log("toggle audio");
    }}
    title={"CIRCLEVERSE"}
    description={`©mel 2021 | mp4 | 1500x1500 | 25/25 \nThis is an experimental social token of recognition for the metaverse projkt as part of the #CIRCULUS event.`}
  />
</main>

<style>
  :global(html),
  :global(body) {
    background-color: rgb(10, 10, 10);
    padding: 0;
    margin: 0;
  }

  :global(body) {
    width: 100vw;
    height: calc(100vh - var(--vh-offset, 0px));
    overflow: hidden;
  }

  main {
    text-align: center;
    width: 100vw;
    height: calc(100vh - var(--vh-offset, 0px));
    overflow: hidden;
  }
  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
